import React from "react";

const SocialLinksContext = React.createContext("SocialLinksContext")

export default SocialLinksContext